import partsIndexTable from "./partsIndexTable";
import issuesIndexTable from "./issuesIndexTable";
import machinesIndexTable from './machinesIndexTable';
import toolsIndexTable from "./toolsIndexTable";
import staffIndexTable from "./staffIndexTable";
import storageIndexTable from "./storageIndexTable";
import plantsIndexTable from "./plantsIndexTable";
import buildingsIndexTable from "./buildingsIndexTable";
import floorsIndexTable from "./floorsIndexTable";

const TABLE_HEADERS = Object.freeze({
    partsIndexTable,
    issuesIndexTable,
    machinesIndexTable,
    toolsIndexTable,
    staffIndexTable,
    storageIndexTable,
    plantsIndexTable,
    buildingsIndexTable,
    floorsIndexTable
})

export function getTableHeaders(tableName) {
    if (!TABLE_HEADERS?.[tableName]) throw new Error(`Table headers for table name: [${tableName}] not defined!`);
    return TABLE_HEADERS[tableName];

}